import React from 'react';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';

const McqConfirmationModal = ({ isOpen, onClose, onStart }) => {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onStart}
      type="info"
      title="Start Quiz"
      description="Are you sure you want to start this quiz? Once started, the timer will begin and cannot be paused."
      confirmText="Start Quiz"
      cancelText="Cancel"
    />
  );
};

export default McqConfirmationModal;
